import { render, staticRenderFns } from "./UnicodeCodec.vue?vue&type=template&id=8dd8b570&scoped=true"
import script from "./UnicodeCodec.vue?vue&type=script&lang=js"
export * from "./UnicodeCodec.vue?vue&type=script&lang=js"
import style0 from "./UnicodeCodec.vue?vue&type=style&index=0&id=8dd8b570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd8b570",
  null
  
)

export default component.exports